// extracted by mini-css-extract-plugin
export var scrollArea = "_ot-0";